import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useLocation} from 'react-router-dom';

const MenuEntry = ({link, dropdownItem, children}) => {

  const location = useLocation();
  const navigate = useNavigate();
  const [currentUrlPath, setCurrentUrlPath] = useState();

  useEffect(
    () => { setCurrentUrlPath(location.pathname); },
    [location.pathname]
  );

  const goToLink = () => navigate(link);

  const currentlyActive = () => currentUrlPath &&
    link && link.indexOf(currentUrlPath) >= 0;

  const linkClassName = () => {
    if (dropdownItem) {
      return 'dropdown-item';
    } else {
      let result = 'nav-link';
      if (currentlyActive()) {
        result += ' active';
      }
      return result;
    }
  };

  return <li className={!dropdownItem ? 'nav-item' : ''}>
    <a href="#"
       className={linkClassName()}
       onClick={() => goToLink()}>
      {children}
    </a>
  </li>;
};

export default MenuEntry;
